import React from "react";
import { motion } from "framer-motion";
import AnimatedSection from "./AnimatedSection";
import SectionHeader from "./SectionHeader";

const integrations = [
  { name: "OpenAI", logo: "https://cdn.simpleicons.org/openai/412991" },
  { name: "ChatGPT", logo: "https://cdn.simpleicons.org/openai/74AA9C" },
  { name: "WhatsApp", logo: "https://cdn.simpleicons.org/whatsapp/25D366" },
  { name: "Facebook Messenger", logo: "https://cdn.simpleicons.org/facebook/1877F2" },
  { name: "Instagram", logo: "https://cdn.simpleicons.org/instagram/E4405F" },
  { name: "Slack", logo: "https://cdn.simpleicons.org/slack/4A154B" },
  { name: "HubSpot", logo: "https://cdn.simpleicons.org/hubspot/FF7A59" },
  { name: "Salesforce", logo: "https://cdn.simpleicons.org/salesforce/00A1E0" },
  { name: "Shopify", logo: "https://cdn.simpleicons.org/shopify/7AB55C" },
  { name: "Zendesk", logo: "https://cdn.simpleicons.org/zendesk/03363D" },
  { name: "Google Dialogflow", logo: "https://cdn.simpleicons.org/googlecloud/4285F4" },
];

const ChatBotIntegrations: React.FC = () => (
  <AnimatedSection as="section" className="cbot-section" aria-labelledby="cbot-integrations-title">
    <div className="cbot-container">
      <SectionHeader
        eyebrow="AI Integrations"
        title="Seamlessly Connect With Your Tech Stack"
        text="We integrate with leading AI platforms, CRMs, and messaging channels for unified automation."
      />

      <div className="cbot-integration-grid">
        {integrations.map((item, index) => (
          <motion.article
            key={item.name}
            className="cbot-integration-card"
            initial={{ opacity: 0, scale: 0.94 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: index * 0.04 }}
            whileHover={{ y: -6, scale: 1.03 }}
          >
            <img src={item.logo} alt={`${item.name} logo`} loading="lazy" />
            <span>{item.name}</span>
          </motion.article>
        ))}
      </div>
    </div>
  </AnimatedSection>
);

export default ChatBotIntegrations;
